<div class="bg-workspace min-vh-100">
  <top-bar [title]="'Subscriptions'"></top-bar>
  <div class="container py-4 px-md-5">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">Subscriptions</li>
      </ol>
    </nav>

    <div class="row mb-4">
      <div class="col-auto mb-3 mb-sm-0">
        <h4 class="mb-0">Subscriptions</h4>
        <small class="text-muted">Monthly invoice-ready subscription counts per school.</small>
      </div>
    </div>

    <div class="card">
      <form class="card-header row gy-2 gy-md-4 gx-3">
        <div class="col-12 col-sm-5 col-lg-3">
          <app-month-picker
            [label]="'Billing month'"
            [value]="month"
            (valueChange)="month = $event; load()"
          ></app-month-picker>
        </div>
        <app-paginator
          class="col-auto ms-auto"
          [data]="invoicePage"
          [pageable]="invoicePageable"
          (newPage)="switchInvoicePage($event)"
        ></app-paginator>
        <div class="col-auto my-auto">
          <button
            *ngIf="reports.length"
            class="btn btn-primary rounded-pill text-nowrap px-3 py-2"
            type="button"
            (click)="exportInvoice()"
          >
            Download as .xlsx
          </button>
        </div>
      </form>

      <div class="card-body">
        <div *ngIf="loading" class="d-flex py-4">
          <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
        </div>
        <span *ngIf="!loading && !reports.length">
          There is no data to show for {{ month }}.
        </span>
        <div *ngIf="!loading && reports.length" class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr class="table-row table-row-head text-nowrap">
                <th class="sticky-col text-body fw-semibold">School</th>
                <th colspan="4" class="text-center group-start text-body fw-semibold group-line">Student registrations</th>
                <th colspan="4" class="text-center group-start text-body fw-semibold group-line">Teacher registrations</th>
                <th colspan="4" class="text-center group-start text-body fw-semibold group-line">Teacher subscriptions</th>
                <th colspan="2" class="text-center group-start text-body fw-semibold group-line">Payable</th>
                <th class="text-center group-start text-body fw-semibold">Stopped</th>
                <th class="text-center text-body fw-semibold">Expired</th>
                <th class="text-center text-body fw-semibold">Pay for</th>
                <th></th>
              </tr>
              <tr class="table-row table-row-head text-nowrap">
                <th class="sticky-col"></th>
                <th class="text-center sub-head fw-normal group-start">New</th>
                <th class="text-center sub-head fw-normal" title="Manual renewals">Manual</th>
                <th class="text-center sub-head fw-normal" title="Automatic renewals">Auto</th>
                <th class="text-center sub-head fw-semibold">Payable</th>
                <th class="text-center sub-head fw-normal group-start">New</th>
                <th class="text-center sub-head fw-normal" title="Manual renewals">Manual</th>
                <th class="text-center sub-head fw-normal" title="Automatic renewals">Auto</th>
                <th class="text-center sub-head fw-semibold">Payable</th>
                <th class="text-center sub-head fw-normal group-start">New</th>
                <th class="text-center sub-head fw-normal" title="Manual renewals">Manual</th>
                <th class="text-center sub-head fw-normal" title="Automatic renewals">Auto</th>
                <th class="text-center sub-head fw-semibold">Payable</th>
                <th class="text-center sub-head fw-normal group-start">Students</th>
                <th class="text-center sub-head fw-normal">Teachers</th>
                <th class="group-start"></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="table-body">
              <tr
                *ngFor="let report of invoicePage?.content"
                class="table-row cursor-pointer"
                (click)="showAudit(report)"
              >
                <td class="sticky-col" [title]="report.schoolName">{{ report.schoolName }}</td>
                <td class="text-center group-start">{{ report.newStudentRegistrations }}</td>
                <td class="text-center">{{ report.manualRenewedStudentRegistrations }}</td>
                <td class="text-center">{{ report.automaticRenewedStudentRegistrations }}</td>
                <td class="text-center fw-semibold">{{ report.payableStudentRegistrations }}</td>
                <td class="text-center group-start">{{ report.newTeacherRegistrations }}</td>
                <td class="text-center">{{ report.manualRenewedTeacherRegistrations }}</td>
                <td class="text-center">{{ report.automaticRenewedTeacherRegistrations }}</td>
                <td class="text-center fw-semibold">{{ report.payableTeacherRegistrations }}</td>
                <td class="text-center group-start">{{ report.newTeacherSubscriptions }}</td>
                <td class="text-center">{{ report.manualRenewedTeacherSubscriptions }}</td>
                <td class="text-center">{{ report.automaticRenewedTeacherSubscriptions }}</td>
                <td class="text-center fw-semibold">{{ report.payableTeacherSubscriptions }}</td>
                <td class="text-center group-start fw-semibold">{{ report.payableStudents }}</td>
                <td class="text-center fw-semibold">{{ report.payableTeachers }}</td>
                <td class="text-center group-start">{{ report.stoppedSubscriptions }}</td>
                <td class="text-center">{{ report.expiredSubscriptions }}</td>
                <td class="text-center fw-bold">{{ report.totalPayable }}</td>
                <td class="text-end">
                  <a
                    class="btn btn-outline-secondary-2 rounded-circle p-2"
                    [routerLink]="['/admin/school', report.schoolId, 'dashboard']"
                    (click)="$event.stopPropagation()"
                  >
                    <app-icon name="open" class="icon-primary"></app-icon>
                  </a>
                </td>
              </tr>
            </tbody>
            <tfoot *ngIf="totals">
              <tr class="table-row fw-bold">
                <td class="sticky-col">{{ totals.schoolName }}</td>
                <td class="text-center group-start">{{ totals.newStudentRegistrations }}</td>
                <td class="text-center">{{ totals.manualRenewedStudentRegistrations }}</td>
                <td class="text-center">{{ totals.automaticRenewedStudentRegistrations }}</td>
                <td class="text-center fw-semibold">{{ totals.payableStudentRegistrations }}</td>
                <td class="text-center group-start">{{ totals.newTeacherRegistrations }}</td>
                <td class="text-center">{{ totals.manualRenewedTeacherRegistrations }}</td>
                <td class="text-center">{{ totals.automaticRenewedTeacherRegistrations }}</td>
                <td class="text-center fw-semibold">{{ totals.payableTeacherRegistrations }}</td>
                <td class="text-center group-start">{{ totals.newTeacherSubscriptions }}</td>
                <td class="text-center">{{ totals.manualRenewedTeacherSubscriptions }}</td>
                <td class="text-center">{{ totals.automaticRenewedTeacherSubscriptions }}</td>
                <td class="text-center fw-semibold">{{ totals.payableTeacherSubscriptions }}</td>
                <td class="text-center group-start fw-semibold">{{ totals.payableStudents }}</td>
                <td class="text-center fw-semibold">{{ totals.payableTeachers }}</td>
                <td class="text-center group-start">{{ totals.stoppedSubscriptions }}</td>
                <td class="text-center">{{ totals.expiredSubscriptions }}</td>
                <td class="text-center fw-bold">{{ totals.totalPayable }}</td>
                <td></td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>

<app-modal #auditModal size="xl">
  <div class="modal-content">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold" *ngIf="auditSchool">
          Audit — {{ auditSchool.schoolName }}
        </h5>
        <span class="text-muted small">All subscription events recorded for {{ month }}</span>
      </div>
      <app-paginator
        class="ms-auto my-auto"
        [data]="auditPage"
        [pageable]="auditPageable"
        (newPage)="switchAuditPage($event)"
      ></app-paginator>
      <button
        *ngIf="auditPage?.content?.length"
        class="btn btn-primary rounded-pill ms-3 my-auto text-nowrap px-3 py-2"
        type="button"
        (click)="exportAudit()"
      >
        Download as .xlsx
      </button>
      <button
        type="button"
        class="btn-close ms-3 my-auto"
        (click)="auditModal.hide()"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body">
      <div *ngIf="auditLoading" class="d-flex py-4">
        <div class="spinner-border text-primary mx-auto" role="status" aria-hidden="true"></div>
      </div>
      <span *ngIf="!auditLoading && !auditPage?.content?.length">
        No subscription events recorded for {{ month }}.
      </span>
      <div *ngIf="!auditLoading && auditPage?.content?.length" class="table-responsive">
        <table class="table table-sm">
          <thead>
            <tr class="table-row table-row-head text-nowrap">
              <th>Person</th>
              <th>Product</th>
              <th>Event</th>
              <th>Source</th>
              <th>Billing month</th>
              <th>Effective date</th>
              <th>Status</th>
              <th>Notes</th>
            </tr>
          </thead>
          <tbody class="table-body">
            <tr *ngFor="let event of auditPage.content" class="table-row">
              <td class="text-nowrap">{{ personName(event.person) }}</td>
              <td class="text-nowrap">{{ productLabel(event.productType) }}</td>
              <td>
                <span
                  class="text-uppercase badge xsmall rounded-2 w-fit-content"
                  [ngClass]="eventBadgeClass(event)"
                >
                  {{ eventLabel(event) }}
                </span>
              </td>
              <td class="text-lowercase">{{ event.eventSource }}</td>
              <td>{{ event.billingMonth }}</td>
              <td class="text-nowrap">{{ event.effectiveDate | date : 'd/MM/yyyy' }}</td>
              <td>{{ event.subscriptionStatus }}</td>
              <td>{{ event.notes }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</app-modal>
